import { create } from 'zustand';
import { immer } from 'zustand/middleware/immer';
import { CollapseType } from '@meitu/saas-editor-ui';
import { TabEnum } from '@/types';

export interface IElementCollapseModel {
    /**
     * 当前元素内tab
     */
    elementCurTab: TabEnum;

    /**
     * 来源信息
     */
    from: CollapseType | null;

    /**
     * 设置当前元素内tab
     */
    setElementCurTab: (payload: TabEnum) => void;

    /**
     * 设置来源信息
     */
    setFrom: (payload: CollapseType | null) => void;

    /**
     * 是否显示二级返回标题（进入专题列表需要展示二级返回标题）
     */
    showSubBackTitle: boolean;

    /**
     * 设置是否显示二级返回标题
     */
    setShowSubBackTitle: (payload: boolean) => void;
}

const useElementCollapseModel = create<IElementCollapseModel>()(
    immer((set) => ({
        elementCurTab: TabEnum.MATERIAL_MENU,

        from: null,

        showSubBackTitle: false,

        setShowSubBackTitle: (payload) =>
            set((state) => {
                state.showSubBackTitle = payload;
            }),

        setElementCurTab: (payload) =>
            set((state) => {
                state.elementCurTab = payload;
            }),

        setFrom: (payload) =>
            set((state) => {
                state.from = payload;
            }),
    })),
);

export { useElementCollapseModel };
export const getElementCollapseModel = () => useElementCollapseModel.getState();
